/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type PermissionEntityType = typeof PermissionEntityType[keyof typeof PermissionEntityType];


export const PermissionEntityType = {
  General: 'General',
  Permissions: 'Permissions',
  ActionModules: 'ActionModules',
  ServiceModules: 'ServiceModules',
  ShopModules: 'ShopModules',
  Groups: 'Groups',
  Employees: 'Employees',
  CompanyManagementUsers: 'CompanyManagementUsers',
  SubCompanies: 'SubCompanies',
  AdministratorUsers: 'AdministratorUsers',
  AdministratorGeneral: 'AdministratorGeneral',
  AdministratorPermissions: 'AdministratorPermissions',
  AdministratorCompanies: 'AdministratorCompanies',
} as const;
